import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieModule } from 'ngx-cookie';

import { AppComponent } from './app.component';

import { CoreModule, xsrfCookieName, xsrfHeaderName } from './core/core.module';

import { AppRoutingModule } from './app.routing';
import { LoginModule } from './login/login.module';

const appConfig = {
  apiEndpoint: 'api',
  pollingInterval: 30 * 1000
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${appConfig.apiEndpoint}/localization/`, '');
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        AppRoutingModule,
        CookieModule.forRoot(),
        CoreModule.forRoot(appConfig),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        LoginModule], providers: [provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({ cookieName: xsrfCookieName, headerName: xsrfHeaderName }))] })
export class AppModule {}
